"use client";
import { useEffect } from "react";

export default function GlobalError({ error }) {
  // global-error must include html and body tags

  useEffect(() => {
    const reload = sessionStorage.getItem("reload");

    if (reload === null) {
      console.error(error);

      sessionStorage.setItem("reload", true);
      location.reload();
    }
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went wrong!</h2>
      </body>
    </html>
  );
}
